import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import ModalDialog from 'common/components/modal/modal_dialog';
import AnimatedButton from 'common/components/animated_button';
import { SelectField, TextAreaField, DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';

/**
 * Report violation modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */

/* definitions for each type of violation */
const VIOLATIONS = {
  project: {
    modal_title: "Report problem with project",
    title: "Report a problem with this project",
    sub_title: ({ onClose }) => <span>
      This form is only for reporting problems with projects.<br/>
      If you need help with anything else,
      please <Link onClick={onClose} to="/help/contact/">contact us</Link>.
    </span>,
    fields: [{
      name: 'whats_wrong',
      label: "What's wrong?",
      type: 'select',
      required: true,
      options: [
        { field: 'scope', label: 'Client is asking for too much work' },
        { field: 'concept', label: 'Client is asking people to copy others' },
        { field: 'offsite', label: 'Client is asking contact offsite' },
        { field: 'category', label: 'Requested work is not appropriate for project category' },
        { field: 'other', label: 'Other' },
      ]
    }, {
      name: 'details',
      label: 'Please explain:',
      type: 'textarea',
      required: true
    }]
  },
  entry: {
    modal_title: "Report violation",
    title: 'Report a Violation',
    sub_title: () => 'We respect Intellectual Property.',
    fields: [{
      name: 'whats_wrong',
      label: "What's wrong?",
      type: 'select',
      required: true,
      options: [
        { field: 'copyright', label: "It's a violation of copyright" },
        { field: 'offensive', label: "It's offensive" },
        { field: 'inappropriate', label: "It's otherwise innapropriate" },
      ]
    }, {
      name: 'details',
      label: 'Why is this a violation?',
      type: 'textarea',
      required: true,
    }, {
      name: 'additional_links',
      label: 'Additional links (each on a separate line):',
      type: 'textarea',
      required: false,
      renderBefore: (info) => {
        return (
          <div className="extra-info">
            <h5>Entry Link:</h5>
            <Link to={info.link} target="_blank">{info.link}</Link>
          </div>
        )
      }
    }]
  }
};

let Form = ({ error, handleSubmit, submitting, submitFailed, info, definition, onClose }) => (
  <form onSubmit={handleSubmit}>
    { definition.fields.map((field, i) => {
        const Component = { select: SelectField, textarea: TextAreaField }[field.type];
        const before = field.renderBefore? field.renderBefore(info) : null;
        return (
          <fieldset key={i}>
            { before }
            <Field name={field.name} label={field.label} component={Component}
              options={field.options} allowEmpty={true} rows={5} />
          </fieldset>
        );
      }) }

    <div className="modal-actions">
      <AnimatedButton processing={submitting} type="submit" label="Send"
        processingLabel="Sending..." errorMsg={error || submitFailed} successMsg="Done!"/>

      <button className="btn btn-text btn-block" onClick={onClose}>Cancel</button>
    </div>
  </form>
)

const validate = (values, { definition }) => {
  const errors = {}
  definition.fields.forEach(field => {
    if (field.required && !values[field.name]) {
      errors[field.name] = DEFAULT_REQUIRED_MESSAGE;
    }
  })
  return errors
}

Form = reduxForm({
  form: "ViolationModal",
  validate
})(Form);


export default class ViolationModal extends Component {
  constructor(props) {
    super(props);

    this.state = { done: false };

    this.handleDone = this.handleDone.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDone() {
    this.setState({ done: false });
    this.props.onClose();
  }

  handleSubmit(formData) {
    const { reportRequest, info } = this.props;

    return reportRequest({ ...info, ...formData })
      .then(() => this.setState({ done: true }))
      .catch(res => {
        throw new SubmissionError({ _error: 'Failed to report violation. Please try again.' });
      })
  }

  render() {
    const { done } = this.state;
    const { onClose, info } = this.props;
    const definition = info? VIOLATIONS[info.type] : null;

    if (!info || !definition) {
      return null;
    }

    return (
      <ModalDialog modalOpen={true} modalHeader={definition.modal_title}
         dialogClasses="violation-modal" closeAction={onClose}>

        {!done?
        <div>
          <h2>{ definition.title }</h2>
          <p>{ definition.sub_title(this.props) }</p>

          <Form {...this.props} definition={definition} onSubmit={this.handleSubmit} />
        </div>:
        <div className="done">
          <h2>
            <i className="fa fa-check-circle"/><br/>Report Sent
          </h2>

          <p>Thank you for helping us make crowdspring better.</p>

          <div className="modal-actions">
            <button className="btn btn-primary" onClick={this.handleDone}>Done</button>
          </div>
        </div>}

      </ModalDialog>)
  }
}

ViolationModal.propTypes = {
  info: PropTypes.object,
  onClose: PropTypes.func,
  reportRequest: PropTypes.func,
};



// WEBPACK FOOTER //
// ./project/components/violation_modal.jsx